import { LightTheme } from "../Components/UI/Themes/LightTheme";
import { createTransform } from "redux-persist";
import { DarkTheme } from "../Components/UI/Themes/DarkTheme";
import { LanguageEnum } from "jadro-pico/enums/common/LanguageEnum.ts";

export const NO_SNACKBAR_ID = 0;

export interface AppCoreState {
  isAppLeftNavToggled: boolean;
  snackbarSupportingText: string | null;
  snackbarActionLabel: string | null;
  snackbarId: number;
  colorThemeName: string;
  language: LanguageEnum;
}

export enum AppCoreActionEnum {
  APP_LEFT_NAV_TOGGLE = "APP_LEFT_NAV_TOGGLE",
  APP_SET_SNACKBAR = "APP_SET_SNACKBAR",
  APP_COLOR_THEME_TOGGLE = "APP_COLOR_THEME_TOGGLE",
  APP_LANGUAGE_CHANGE = "APP_LANGUAGE_CHANGE",
}

export interface SnackbarPayload {
  text: string | null;
  actionLabel: string | null;
  id: number;
}

type AppCoreAction =
  | { type: AppCoreActionEnum.APP_LEFT_NAV_TOGGLE }
  | { type: AppCoreActionEnum.APP_SET_SNACKBAR; payload: SnackbarPayload }
  | { type: AppCoreActionEnum.APP_COLOR_THEME_TOGGLE }
  | { type: AppCoreActionEnum.APP_LANGUAGE_CHANGE; value: string };

const initialState: AppCoreState = {
  isAppLeftNavToggled: false,
  snackbarSupportingText: null,
  snackbarActionLabel: null,
  snackbarId: NO_SNACKBAR_ID,
  colorThemeName: LightTheme.name,
  language: LanguageEnum.CS,
};

const appCoreReducer = (
  state: AppCoreState = initialState,
  action: AppCoreAction,
): AppCoreState => {
  switch (action.type) {
    case AppCoreActionEnum.APP_LEFT_NAV_TOGGLE:
      return {
        ...state,
        isAppLeftNavToggled: !state.isAppLeftNavToggled,
      };
    case AppCoreActionEnum.APP_SET_SNACKBAR:
      return {
        ...state,
        snackbarSupportingText: action.payload.text,
        snackbarActionLabel: action.payload.actionLabel,
        snackbarId: action.payload.id,
      };
    case AppCoreActionEnum.APP_COLOR_THEME_TOGGLE:
      return {
        ...state,
        colorThemeName: state.colorThemeName === LightTheme.name ? DarkTheme.name : LightTheme.name,
      };
    case AppCoreActionEnum.APP_LANGUAGE_CHANGE:
      return {
        ...state,
        language: action.value as LanguageEnum,
      };
    default:
      return state;
  }
};

export default appCoreReducer;

export const appLeftNavToggleAction = () => ({
  type: AppCoreActionEnum.APP_LEFT_NAV_TOGGLE,
});

export const appSetSnackbar = (payload: SnackbarPayload) => ({
  type: AppCoreActionEnum.APP_SET_SNACKBAR,
  payload,
});

export const appColorThemeToggleAction = () => ({
  type: AppCoreActionEnum.APP_COLOR_THEME_TOGGLE,
});

export const forgetSnackbarWhenPersisted = createTransform(
  (state: AppCoreState) => ({
    ...state,
    snackbarSupportingText: null,
    snackbarActionLabel: null,
    snackbarId: NO_SNACKBAR_ID,
  }),
  (state: AppCoreState) => ({
    ...state,
    snackbarSupportingText: null,
    snackbarActionLabel: null,
    snackbarId: NO_SNACKBAR_ID,
  }),
  { whitelist: ["core"] },
);

export const languageChangeAction = (language: LanguageEnum) => ({
  type: AppCoreActionEnum.APP_LANGUAGE_CHANGE,
  value: language,
});
